
  <div class="row row-mosaic">
    <h4 *ngIf="!materiales.length" style="margin-left: 15px;">{{language.CARGANDO}}</h4>
    <div class="col-md-3 col-sm-6 col-xs-12" *ngFor="let material of materiales" (click)="emitMaterial(material)">
      <div class="img-mosaic-title">
        <span>{{material.NOMBRE}}</span>
      </div>
      <div class="mosaic img-mosaic-simple">
        <div [style.background-image]="'url('+ material.IMAGENURL + ')'" class="img-mosaic-simple mosaic-img-container animate__animated animate__fadeIn">
          <!-- <img [src]="material.IMAGENMINIURL"> -->
        </div>
      </div>
    </div>
  </div>

